var E;
(function(o) {
  o.BORDER_BOX = "border-box", o.CONTENT_BOX = "content-box", o.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(E || (E = {}));
export {
  E as ResizeObserverBoxOptions
};
